/**
 * TICTAC 2 GO — floating nav visibility + scroll-to handlers
 */
(function () {
  var nav = document.querySelector('[data-floating-nav]');
  if (nav) {
    var frame = 0;
    function update() {
      if (window.scrollY > 120) {
        nav.classList.add('is-visible');
      } else {
        nav.classList.remove('is-visible');
      }
      frame = 0;
    }
    function handleScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-scroll-to]');
    if (!trigger) return;
    var selector = trigger.getAttribute('data-scroll-to');
    if (!selector) return;
    var target = document.querySelector(selector);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
